export default {
  name: 'approval_device_clear',
  path: '/approval/device_clear',
  component: () =>
    import(/* webpackChunkName: "approval_device_clear" */ './index.vue')
}
